import React from 'react';
import PropTypes from 'prop-types';
import BasicTooltip from '../../../../../../components/BasicTooltip';
import LinkButton from '../../../../../../components/LinkButton';
import LinkBuilder from '../../../../../../helpers/link-builder';

const ApplicantHistoryWidgetItem = props => {
  const { row } = props;
  const {
    CandidateID,
    FullName,
    Date,
    PositionTitle,
    Total,
    AllowView,
    Type,
  } = row;

  return (
    <div className="sidebar__table-row">
      <BasicTooltip
        tooltip={`Applied for ${PositionTitle} ${Type.toLowerCase()} on ${Date}`}
      >
        <div className="sidebar__table-column">
          {AllowView === 'Yes' ? (
            <LinkButton
              target="_blank"
              text={FullName}
              to={LinkBuilder.getProfileLink(CandidateID)}
              btnFontWeight="600"
              btnFontSize="0.8571rem"
              underline={false}
              btnFontFamily="Noto Sans"
            />
          ) : (
            <strong>{FullName}</strong>
          )}
        </div>
        <div className="sidebar__table-column">
          <div className="sidebar__text">{Total}</div>
        </div>
        <div className="sidebar__table-column">
          <div className="sidebar__text">{Date}</div>
        </div>
      </BasicTooltip>
    </div>
  );
};

ApplicantHistoryWidgetItem.propTypes = {
  row: PropTypes.object.isRequired,
};

export default ApplicantHistoryWidgetItem;
